<template>
  <validation-provider :name="name" ref="prov" :vid="vid" :rules="rules" v-slot="{ errors }">
    <ValidationTooltip
      :expanded="expandedTooltip"
      @clicked="clearErrors"
      :show="shouldShowTooltip(errors)"
      :errors="errors"
      :arrowPosition="tooltipArrowPosition"
      :positionBottom="tooltipPositionBottom"
    />
    <slot v-bind:clear="clearErrors"/>
  </validation-provider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import ValidationTooltip from '@/components/common/validation/ValidationTooltip';

export default {
  name: 'ValidationWrapper',
  props: {
    value: {
      default: '',
    },
    rules: String,
    vid: String,
    name: String,
    expandedTooltip: Boolean,
    tooltipArrowPosition: String,
    tooltipPositionBottom: Number,
  },
  components: { ValidationProvider, ValidationTooltip },
  data() {
    return {
      isWaiting: false,
    };
  },
  methods: {
    clearErrors() {
      this.$refs['prov'].reset();
    },
    shouldShowTooltip(errors) {
      const result = (errors[0]);
      if (result && !this.isWaiting) {
        window.setTimeout(() => {
          this.clearErrors();
          this.isWaiting = false;
        }, 3000);
        this.isWaiting = true;
      }
      return !!result;
    },
  },
};
</script>
